import React from 'react';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultServiceTemplate } from '@/utils/serviceDefaultTemplate';
import { ACLAuthorizationRequest } from '@/api/bol';

export interface ServiceFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; serviceJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const ServiceFormDialog: React.FC<ServiceFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; serviceJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    // Transform the generic jsonData back to the expected serviceJson field
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      serviceJson: data.serviceJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations
    };
    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Service"
      jsonFieldName="serviceJson"
      defaultJsonTemplate={defaultServiceTemplate()}
      jsonLabel="Enter a valid Service JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Service schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};